import { Text } from '../1elements'
import makeStyles from '@material-ui/core/styles/makeStyles'
import DataRecordStatusTable from '../3modules/DataImportApproval/DataRecordStatusTable'
import DataVisibilitySwitch from '../3modules/DataImportApproval/DataVisibilitySwitch'
import GoBackButton from '../1elements/Buttons/IconButtons/GoBackButton'

const useStyles = makeStyles({
  root: {
    margin: '15px 0'
  },
  errorMessage: {
    textAlign: 'center',
    width: '100%',
    padding: '40px'
  },
  headerDiv: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  pageHeader: {
    marginRight: 'auto'
  },
  backButton: {
    marginLeft: 20
  }
})

const DataRecordStatusTemplate = ({ recordStatusData, totalPosts, currentPage, setCurrentPage, checked, onChange }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.headerDiv}>
        <Text type='dataRecordStatusTabHeader' className={classes.pageHeader}>Approve/Reject Data Records</Text>
        <DataVisibilitySwitch checked={checked} onChange={onChange} />
        <GoBackButton className={classes.backButton} />
      </div>

      {
                recordStatusData.length > 0
                  ? (
                    <DataRecordStatusTable
                      recordStatusData={recordStatusData} totalPosts={totalPosts}
                      currentPage={currentPage} setCurrentPage={setCurrentPage}
                    />
                    )
                  : (
                    <div className={classes.errorMessage}>
                      <Text type='tabHeadingSecondary'>
                        Currently there are no pending/rejected data records
                      </Text>
                    </div>
                    )
            }

    </div>
  )
}

export default DataRecordStatusTemplate
